import { useState, ChangeEvent } from 'react';

import { SelectFieldComponent } from '@vaa-component-lib/component.atom.select-field';

import { ActionType } from '../../types/rooms';

interface ChildComponentProps {
	age: number;
	childIdx: number;
	roomIdx: number;
	dispatch: React.Dispatch<ActionType>;
}

const ChildAgeComponent = ({
	age,
	childIdx,
	roomIdx,
	dispatch
}: ChildComponentProps) => {
	const [valid, setValid] = useState(age > 0);
	const changeAge = (event: ChangeEvent) => {
		const target = event.target as HTMLSelectElement;
		const age = parseInt(target.value);

		setValid(!age ? false : true);
		dispatch({
			type: 'CHANGE_CHILD_AGE',
			roomIndex: roomIdx,
			ageIndex: childIdx,
			age: age
		});
	};
	return (
		<SelectFieldComponent
			data-cy="child-age-component"
			placeholder="Select"
			label={`Child ${childIdx + 1} age`}
			onChange={(e: ChangeEvent) => changeAge(e)}
			key={childIdx}
			id={`child-age-${childIdx}`}
			hasError={!valid}
			value={`${age}`}
			options={[...Array(17).keys()].map((option) => {
				return {
					name: option === 0 ? '<2' : `${option + 1}`,
					value: `${option + 1}`
				};
			})}
		/>
	);
};

export default ChildAgeComponent;
